/*
This file is a copy of buttons.bootstrap4.js but with additional classes added
for Aurion styling. The factory function was also removed from the original file
because this will only be run in the browser.
*/
'use strict';
var DataTable = $.fn.dataTable;

$.extend( true, DataTable.Buttons.defaults, {
    dom: {
        container: {
            className: 'dt-buttons'
        },
        button: {
            className: 'btn btn-outline-secondary btn-sm'
        },
        collection: {
            tag: 'div',
            className: 'dt-button-collection dropdown-menu',
            button: {
                tag: 'a',
                className: 'btn-sm dt-button dropdown-item',
                active: 'active',
                disabled: 'disabled'
            }
        }
    }
} );

DataTable.ext.buttons.collection.className += ' dropdown-toggle';
